/* src/app/modules/subscription/monthly-downgrade-dialog/monthly-downgrade-dialog.component.css */
.monthly-downgrade-container {
  padding: 0;
}
.monthly-downgrade-content {
  padding: 40px 32px;
  text-align: center;
  background:
    linear-gradient(
      135deg,
      #f5f7fa 0%,
      #ffffff 100%);
}
.monthly-downgrade-icon {
  font-size: 48px;
  margin-bottom: 20px;
  display: inline-block;
  animation: bounce 0.8s ease-in-out;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.monthly-downgrade-title {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.3;
}
.monthly-downgrade-subtitle {
  margin: 0 0 32px 0;
  font-size: 14px;
  color: #666666;
  font-weight: 500;
}
.monthly-downgrade-benefits {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
  text-align: left;
}
.benefit-item {
  display: flex;
  gap: 12px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}
.benefit-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}
.benefit-icon {
  font-size: 24px;
  flex-shrink: 0;
  line-height: 1.5;
}
.benefit-text {
  margin: 0;
}
.benefit-text strong {
  display: block;
  color: #1a1a1a;
  margin-bottom: 4px;
  font-size: 14px;
}
.benefit-text p {
  margin: 0;
  color: #666666;
  font-size: 12px;
}
.monthly-downgrade-actions {
  display: flex;
  gap: 12px;
  flex-direction: column;
  margin-top: 20px;
}
.btn {
  padding: 14px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-primary {
  background:
    linear-gradient(
      135deg,
      #d48f00,
      #b8790a);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(212, 143, 0, 0.35);
}
.btn-primary:hover:not(:disabled) {
  background:
    linear-gradient(
      135deg,
      #f7a820,
      #e89311);
  box-shadow: 0 6px 20px rgba(243, 155, 19, 0.45);
  transform: translateY(-2px);
}
.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(212, 143, 0, 0.35);
}
.btn-secondary {
  background-color: transparent;
  color: #666666;
  border: 1px solid #ddd;
}
.btn-secondary:hover {
  background-color: #f9f9f9;
  border-color: #999999;
  color: #333333;
}
@media (max-width: 600px) {
  .monthly-downgrade-container {
    min-width: 100%;
  }
  .monthly-downgrade-content {
    padding: 32px 20px;
  }
  .monthly-downgrade-title {
    font-size: 20px;
  }
  .monthly-downgrade-icon {
    font-size: 40px;
  }
}
.plan-change-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 20px;
  margin: 0 0 24px 0;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: default;
}
/*# sourceMappingURL=monthly-downgrade-dialog.component.css.map */
